import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

const useImprimirArquivo = () => {
    const { token } = useContext(AuthContext);

    const imprimirArquivo = (endpoint: string) => {
        const hasParams = endpoint.includes('?');
        const url = `${process.env.REACT_APP_API}/api/${endpoint}${hasParams ? '&' : '?'}token=${token}`;
        window.open(url, '_blank');
    };

    return imprimirArquivo;
};

export default useImprimirArquivo;